import CircularProgress from "@material-ui/core/CircularProgress";
import { CircularProgressProps } from "@material-ui/core/CircularProgress/CircularProgress";
import React from "react";

interface Props extends CircularProgressProps {
  contained?: boolean;
  width?: number | string;
  height?: number | string;
  size?: number;
}

export function Loader({ contained, width, height, size = 80, thickness = 3, ...props }: Props) {
  const content = (
    <div
      className="cw-absolute"
      style={{
        width: size,
        height: size,
        top: `calc(50% - ${size / 2}px)`,
        left: `calc(50% - ${size / 2}px)`,
      }}
    >
      <CircularProgress {...props} size={size} thickness={thickness} />
    </div>
  );

  return contained ? (
    <div
      className="cw-relative"
      style={{
        width,
        height,
      }}
    >
      {content}
    </div>
  ) : (
    content
  );
}
